import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const getHeaderButtonSx = (theme) => ({
  width: 38,
  height: 38,
  borderRadius: '50%',
  backgroundColor: 'transparent',
  color: theme === 'dark' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.75)',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
  },
});

const getFloatingButtonSx = (themeMode) => {
  const useSecondary = themeMode === 'dark';
  const bg = useSecondary
    ? 'color-mix(in srgb, var(--portal-theme-secondary) 90%, transparent)'
    : 'color-mix(in srgb, var(--portal-theme-color) 90%, transparent)';
  const bgHover = useSecondary ? 'var(--portal-theme-secondary)' : 'var(--portal-theme-color)';
  return {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: bg,
    color: '#ffffff',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    zIndex: 9999,
    '&:hover': {
      backgroundColor: bgHover,
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      transform: 'scale(1.05)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
    transition: 'all 0.2s ease',
  };
};

export default function ThemeToggle({ variant = 'header' }) {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const isHeader = variant === 'header';
  const iconColor = isHeader
    ? (theme === 'dark' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.75)')
    : '#ffffff';

  const iconSize = 20;

  return (
    <IconButton
      onClick={toggleTheme}
      sx={isHeader ? getHeaderButtonSx(theme) : getFloatingButtonSx(theme)}
      aria-label="toggle theme"
    >
      {theme === 'dark' ? (
        <Sun size={iconSize} color={iconColor} />
      ) : (
        <Moon size={iconSize} color={iconColor} />
      )}
    </IconButton>
  );
}
